import { create } from 'zustand';
import { MenuDto } from 'src/dtos/menu/menuDto';

export interface SubMenu {
  id: number;
  title: string;
}

export interface MenuItem {
  id: number;
  title: string;
  subMenuList: SubMenu[];
}

export interface MenuStore {
  menuList: MenuDto[];
  setMenuList: (menuList: MenuDto[]) => void;
  secondMenuList: MenuDto[];
  setSecondMenuList: (menuList: MenuDto[]) => void;
  thirdMenuList: MenuDto[];
  setThirdMenuList: (menuList: MenuDto[]) => void;
  // 4차 메뉴 추가
  fourthMenuList: MenuDto[];
  setFourthMenuList: (menuList: MenuDto[]) => void;
  // 5차 메뉴 추가
  fifthMenuList: MenuDto[];
  setFifthMenuList: (menuList: MenuDto[]) => void;

  openedMenuMap: Record<string, boolean>;
  setOpenedMenuMap: (menuCd: string, isOpen: boolean) => void;
  toggleMenu: (menuCd: string) => void;

  openedSecondMenuMap: Record<string, boolean>;
  setOpenedSecondMenuMap: (menuCd: string, isOpen: boolean) => void;
  toggleSecondMenu: (menuCd: string) => void;

  // 4차 메뉴 열림/닫힘 상태 추가
  openedFourthMenuMap: Record<string, boolean>;
  setOpenedFourthMenuMap: (menuCd: string, isOpen: boolean) => void;
  toggleFourthMenu: (menuCd: string) => void;
  // 5차 메뉴 열림/닫힘 상태 추가
  openedFifthMenuMap: Record<string, boolean>;
  setOpenedFifthMenuMap: (menuCd: string, isOpen: boolean) => void;
  toggleFifthMenu: (menuCd: string) => void;

  selectedThirdMenu: MenuDto | undefined;
  setSelectedThirdMenu: (selectedThirdMenu: MenuDto | undefined) => void;
}

// export const excludeMenu = ['PUR', 'PRD', 'EQM', 'TQC', 'WMS', 'TMP'];
// export const visibleSecondMenu = ['SAL20', 'MST10', 'MST20', 'SYS10', 'SYS40', 'SYS30']
// export const visibleThirdMenu = ['SAL2020_R01', 'MST1010_R01', 'MST2010_R01', 'SYS1010_R01', 'SYS4010_R01', 'SYS3050_R01']
export const defaultMenu = 'FIXED_TAB';

// Zustand 스토어 생성
const useMenuStore = create<MenuStore>((set) => ({
  menuList: [],
  setMenuList: (menuList: MenuDto[]) => set((state) => {
    return {
      ...state,
      menuList
    }
  }),
  secondMenuList: [],
  setSecondMenuList: (menuList: MenuDto[]) => set((state) => {
    return {
      ...state,
      secondMenuList: menuList
    }
  }),
  thirdMenuList: [],
  setThirdMenuList: (menuList: MenuDto[]) => set((state) => {
    return {
      ...state,
      thirdMenuList: menuList
    }
  }),
  fourthMenuList: [],
  setFourthMenuList: (menuList: MenuDto[]) => set((state) => {
    return {
      ...state,
      fourthMenuList: menuList
    }
  }),
  fifthMenuList: [],
  setFifthMenuList: (menuList: MenuDto[]) => set((state) => {
    return {
      ...state,
      fifthMenuList: menuList
    }
  }),

  openedMenuMap: {},
  setOpenedMenuMap: (menuCd: string, isOpen: boolean) => set((state) => ({
    ...state,
    openedMenuMap: {
      ...state.openedMenuMap,
      [menuCd]: isOpen
    }
  })),
  toggleMenu: (menuCd: string) => set((state) => ({
    ...state,
    openedMenuMap: {
      ...state.openedMenuMap,
      [menuCd]: !state.openedMenuMap[menuCd]
    }
  })),

  openedSecondMenuMap: {},
  setOpenedSecondMenuMap: (menuCd: string, isOpen: boolean) => set((state) => ({
    ...state,
    openedSecondMenuMap: {
      ...state.openedSecondMenuMap,
      [menuCd]: isOpen
    }
  })),
  toggleSecondMenu: (menuCd: string) => set((state) => ({
    ...state,
    openedSecondMenuMap: {
      ...state.openedSecondMenuMap,
      [menuCd]: !state.openedSecondMenuMap[menuCd]
    }
  })),

  openedFourthMenuMap: {},
  setOpenedFourthMenuMap: (menuCd: string, isOpen: boolean) => set((state) => ({
    ...state,
    openedFourthMenuMap: {
      ...state.openedFourthMenuMap,
      [menuCd]: isOpen
    }
  })),
  toggleFourthMenu: (menuCd: string) => set((state) => ({
    ...state,
    openedFourthMenuMap: {
      ...state.openedFourthMenuMap,
      [menuCd]: !state.openedFourthMenuMap[menuCd]
    }
  })),
  openedFifthMenuMap: {},
  setOpenedFifthMenuMap: (menuCd: string, isOpen: boolean) => set((state) => ({
    ...state,
    openedFifthMenuMap: {
      ...state.openedFifthMenuMap,
      [menuCd]: isOpen
    }
  })),
  toggleFifthMenu: (menuCd: string) => set((state) => ({
    ...state,
    openedFifthMenuMap: {
      ...state.openedFifthMenuMap,
      [menuCd]: !state.openedFifthMenuMap[menuCd]
    }
  })),

  selectedThirdMenu: undefined,
  setSelectedThirdMenu: (selectedThirdMenu: MenuDto | undefined) => set((state) => {
    return {
      ...state,
      selectedThirdMenu
    }
  })
}));

export default useMenuStore;